import { api_GET } from "api/axios.js";

const destino_api =
{
    getListAtivos: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`destino/GetListAtivos`).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default destino_api
